export default __webpack_public_path__ + "static/media/part_logo5.a334a659.png";